// removed by extract-text-webpack-plugin
module.exports = {"dashboard":"style__dashboard___ALoZQ","content":"style__content___1gwyY","panel":"style__panel___2lSEM","panel-content":"style__panel-content___2xEVs","sign-in-button":"style__sign-in-button___moI3F","global-error":"style__global-error___8dNwK","textfield":"style__textfield___1pjuO"};


//////////////////
// WEBPACK FOOTER
// ./components/LoginPage/style.scss
// module id = 1269
// module chunks = 0